import * as React from "react"

const PlusSVG = (props) => (
	<svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M16.4997 11.9168H11.9163V16.5002C11.9163 17.0043 11.5038 17.4168 10.9997 17.4168C10.4955 17.4168 10.083 17.0043 10.083 16.5002V11.9168H5.49967C4.99551 11.9168 4.58301 11.5043 4.58301 11.0002C4.58301 10.496 4.99551 10.0835 5.49967 10.0835H10.083V5.50016C10.083 4.996 10.4955 4.5835 10.9997 4.5835C11.5038 4.5835 11.9163 4.996 11.9163 5.50016V10.0835H16.4997C17.0038 10.0835 17.4163 10.496 17.4163 11.0002C17.4163 11.5043 17.0038 11.9168 16.4997 11.9168Z"
			fill="#475163"
		/>
	</svg>
)

export default PlusSVG
